var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.banner !== null && _vm.isEnabled)?_c('div',{staticClass:"banner"},[_c('a',{attrs:{"href":_vm.banner.data.banner_link.url,"target":"_blank"}},[_c('div',{staticClass:"banner_image",class:{
                image: _vm.image !== null,
                hasImage: _vm.image !== null
            },style:(_vm.getStyle(_vm.banner))}),_vm._v(" "),(_vm.banner.data.show_title)?_c('div',{staticClass:"banner_title"},[_c('span',{staticClass:"badge"},[_vm._v("Ad")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.description))])]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45636ef0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = null
// module chunks = 